import React from 'react';
import { COMPONENT_TYPES } from '../../../constants';
import TrendingItemsEditor from './TrendingItems.editor';
import TrendingItemsProperties from './TrendingItems.properties';
import { registerComponent, registerSkinnableComponent } from '../registry';
import { TrendingItemsSkinnable } from './TrendingItemsSkinnable';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import TrendingItemsComponent from './TrendingItems.component';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(TrendingItemsSkinnable);

// 외부 스킨 지원을 위한 래퍼 컴포넌트
const TrendingItemsWrapper: React.FC<any> = (props) => {

  return <TrendingItemsComponent {...props} />;
};

// 레거시 호환성을 위한 기존 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.TRENDING_ITEMS || 'TRENDING_ITEMS',
  component: TrendingItemsWrapper,
  editorComponent: TrendingItemsEditor,
  properties: TrendingItemsProperties,
  defaultProps: {
    componentProps: {
      className: 'trending-items-component',
      headingText: 'Trending now',
      subtitle: '에디터가 선정한',
      is_logged: true,
      is_not_logged: true,
      imageRadius: '4px',
      showMoreButton: true,
      moreButtonText: 'MORE',
      moreButtonUrl: '#',
      moreButtonTextColor: '#8a7a6d',
      moreButtonBorderColor: '#8a7a6d',
      moreButtonBgColor: 'transparent',
      moreButtonHoverTextColor: '#ffffff',
      moreButtonHoverBgColor: '#8a7a6d',
      items: [
        {
          id: 1,
          image: "https://via.placeholder.com/400x400",
          title: "민감성 피부 스킨&케어",
          url: "#"
        },
        {
          id: 2,
          image: "https://via.placeholder.com/400x400",
          title: "수분 마스크팩 듀오 할인",
          url: "#"
        },
        {
          id: 3,
          image: "https://via.placeholder.com/400x400",
          title: "저자극 버블 클렌저 기획전",
          url: "#"
        }
      ]
    },
    style: {
      width: '100%',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '40px 20px',
      boxSizing: 'border-box'
    }
  },
  category: 'content',
  icon: '🔥',
  name: '트렌딩 아이템',
  skinnable: TrendingItemsSkinnable
});

// 컴포넌트 및 타입 내보내기
export { TrendingItemsWrapper as TrendingItemsComponent };
export { default as TrendingItemsEditor } from './TrendingItems.editor';
export { default as TrendingItemsProperties } from './TrendingItems.properties';
export * from './TrendingItems.types'; 